export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_selfinvest.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a SelfInvest",
    text: [
      "O portfólio automatizado da SelfInvest foi desenvolvido com metodologia quantitativa robusta, execução de padrões de mercado validados e controle de risco adaptativo ao cenário de mercado. Com histórico validado em conta real, o portfólio demonstrou eficiência operacional e consistência ao longo do tempo. ",
    ],
    testimonial: {
      text: "Automação não é sobre prometer resultados, é sobre seguir processos com disciplina",
      author: {
        name: "Equipe SelfInvest",
        // "picture": "https://i.pravatar.cc/150?img=70"
      },
    },
  },
  stats: {
    title: "Alguns resultados da SelfInvest ",
    data: [
      {
        value: "+14",
        description: "Meses de histórico em conta real",
      },
      {
        value: "87%",
        description: "De rentabilidade acumulada em conta real",
      },
      {
        value: "+70",
        description: "Estratégias validadas ",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da SelfInvest?",
    subtitle: "Veja quais as principais vantagens dos robôs da SelfInvest.",
    data: [
      {
        title: "7 dias para testar",
      },
      {
        title: "100% automatizado",
      },
      {
        title: "Suporte Individual",
      },
      {
        title: "Velocidade",
      },
      {
        title: "Ganhe Tempo",
      },
      {
        title: "Sem emocional ",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão da SelfInvest",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A SelfInvest",
    col1: [
      "A SelfInvest nasceu da convergência entre tecnologia, mercado financeiro e pesquisa quantitativa aplicada ao trading automatizado.",
      "Fundada por profissionais com sólida formação técnica e ampla experiência no desenvolvimento de estratégias sistemáticas, a SelfInvest tem como propósito criar portfólios quantitativos robustos, orientados por dados, estatística e gestão de risco, sempre com foco em consistência e escalabilidade. ",
      "Desde sua origem, a empresa direcionou seus esforços para o desenvolvimento de estratégias automatizadas para, aplicando conceitos avançados de modelagem matemática, análise estatística, controle de volatilidade e adaptação dinâmica às diferentes condições de mercado.",
      "Os portfólios da SelfInvest passaram por um rigoroso processo de validação, incluindo testes históricos extensivos, análises de robustez e acompanhamento contínuo em conta real, acumulando um histórico consistente ao longo do período de operação. ",
    ],
    col2: [
      "A filosofia da Self Invest está fundamentada em três pilares principais: ",
      "Automação inteligente, reduzindo interferências emocionais no processo decisório.",
      "Gestão de risco estruturada, priorizando preservação de capital.",
      "Evolução contínua, com revisões periódicas de modelos, parâmetros e padrões operacionais. ",
      "Todas as estratégias são constantemente monitoradas e ajustadas com base em métricas estatísticas, comportamento do mercado e análises quantitativas aprofundadas, garantindo aderência ao cenário atual e longevidade operacional. ",
      "Invista com método. Invista com dados. Invista com a SelfInvest. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão SelfInvest",
  },
  strategies: {
    title: "Portfólio SelfInvest",
    heading: "Portfólio exclusivo à sua disposição.",
    subtitle:
      "Portfólio validado e desenvolvido por profissionais, ferramentas avançadas de otimização e computação de alta performance.",
  },
  testimonials: [
    {
      text: "O diferencial do portfólio da SelfInvest está na segurança operacional. Tudo é bem definido: Risco, execução e transparência. É um modelo que prioriza consistência e controle, exatamente o que eu buscava",
      author: "Carlos M.",
      job: "Empresário",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
    {
      text: "Essa automação trouxe previsibilidade e disciplina para minha exposição ao mercado. Consigo acompanhar as operações com clareza, sem depender de decisões emocionais",
      author: "Rodrigo S.",
      job: "Servidor Público",
      // "image_url": "https://avatars.githubusercontent.com/u/97165289"
    },
  ],
};
